import Http from 'services/Http';

/**
 * The backend bcrypt-hashes every id (`format: 'id'`) on a single thread, so large
 * batches exceed the 30s gateway timeout (504). Sequential chunks keep each request
 * well under the limit without piling extra CPU load on the API.
 */
export const CHECK_IDS_CHUNK_SIZE = 50;

class HrBot {
  send = async body => Http.post(`/v1/hr-bot/send`, body);

  checkIds = async ({ ids = [], ...rest }) => {
    // Only 'id' lookups are hashed server-side; 'code' lookups are a single cheap
    // indexed query, so they stay as one request. 'id' is also the backend default.
    const chunkSize = (rest.format ?? 'id') === 'id' ? CHECK_IDS_CHUNK_SIZE : ids.length;
    const existingEmployees = {};
    for (let i = 0; i < ids.length; i += chunkSize) {
      const chunk = ids.slice(i, i + chunkSize);
      const response = await Http.post(`/v1/hr-bot/check-ids`, { ...rest, ids: chunk });
      Object.assign(existingEmployees, response.data?.existingEmployees);
    }
    return { existingEmployees };
  };
}

export default new HrBot();
